import useJwt from '@core/auth/jwt/useJwt'
import axios from '@axios'

// axios.defaults.baseURL = REST_ENDPOINT; // now set through region

const { jwt } = useJwt(axios, {
  // Endpoints
  loginEndpoint: '/api/v1/prison-users/tokens',
  refreshEndpoint: '/api/v1/prison-users/tokens/refresh',
  // refreshEndpoint: '/refresh-token',
  // logoutEndpoint: '/logout',

  // This will be prefixed in authorization header with token
  // e.g. Authorization: Bearer <token>
  tokenType: 'Bearer',

  // Value of this property will be used as key to store JWT token in storage
  storageTokenKeyName: 'userTokenPortal',
  storageRefreshTokenKeyName: 'refreshTokenPortal',
})
export default jwt
